import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC4prKWbUUQcQ5AujvF_d2I5ugCjJLNF38",
  authDomain: "swe-wgu.firebaseapp.com",
  projectId: "swe-wgu",
  storageBucket: "swe-wgu.firebasestorage.app",
  messagingSenderId: "394106331611",
  appId: "1:394106331611:web:ba85af88585bbfbf0287fe",
  measurementId: "G-1PQZKXN4VY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Prevents errors in SSR environments like Next.js
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { app, analytics };
